// extracted by mini-css-extract-plugin
export default {"toggle":"toggle___3emdz","open":"open___KvnDF","icon":"icon___1dHwh","small":"small___qXwe1","medium":"medium___2p_5d","large":"large___1W4zG"};